import { useEffect } from 'react';
import { fetchReferenceDataColumnsFromFile } from "../clientRequests";
import { bulkAddNewLoopEntries } from "../../store/actions/client";
import { createNewRow, isTrueStringMatch } from "../utils";
import { referenceDataFileListSelector } from "../../store/selectors/referenceData";
import { useDispatch, useSelector } from 'react-redux';
export const createPrefillRow = ([keyField, ...fields],
// all entries for the row
reference_data_id,
// optional keyField refDataId
columnsIndexed // optional refData file w/ columns indexed by column nmae
) => (value, index) => {
  return createNewRow([{
    ...keyField,
    preFillEntry: true,
    value
  }, ...fields.map(entry => {
    const {
      reference_data_column,
      reference_data_id: refDataId
    } = entry;
    let value = null;
    // since we already have access to reference data, 
    // we can also easily prefill any fields that are from the same file
    if (columnsIndexed && reference_data_column && isTrueStringMatch(reference_data_id, refDataId)) {
      value = columnsIndexed[reference_data_column][index];
    }
    return {
      ...entry,
      preFillEntry: true,
      value: value
    };
  })]).entries;
};
let sheetStore = {};
export const usePreFillRowsEffect = ({
  interactiveClient,
  shouldRun = false,
  limit = 180,
  sheet,
  entries,
  setLoadingState = () => {} // can be used for loaders
}, dependencies) => {
  const {
    id
  } = sheet;
  const refDataFiles = useSelector(referenceDataFileListSelector) || [];
  const dispatch = useDispatch();
  useEffect(() => {
    if (shouldRun && !sheetStore[id]) {
      sheetStore[id] = true;
      const [keyField] = entries;
      const {
        entry_values,
        reference_data_id,
        reference_data_column
      } = keyField;

      // keyfield created from reference data || project/code/customer
      if (reference_data_id) {
        setLoadingState(true);
        fetchReferenceDataColumnsFromFile(reference_data_id).then(({
          data
        }) => {
          const {
            columns
          } = data;
          const file = refDataFiles.find(file => isTrueStringMatch(file.id, reference_data_id));
          // index data columns by colnum name
          const columnsIndexed = file.reference_columns.reduce((acc, colname, i) => ({
            ...acc,
            [colname]: columns[i]
          }), {});
          const keyFieldColumn = columnsIndexed[reference_data_column];
          const newEntries = keyFieldColumn.slice(0, limit).flatMap(createPrefillRow(entries, reference_data_id, columnsIndexed));
          dispatch(bulkAddNewLoopEntries({
            entries: newEntries
          }));
        })
        // TODO: better error handling
        // but failing silently here isn't a big deal
        .catch(e => console.error(e)).finally(() => setLoadingState(false));
      }
      // keyfield created from dropdown options
      else if (entry_values) {
        const newEntries = entry_values.slice(0, limit).reduce((acc, {
          text
        }) => {
          if (text) {
            //avoid prefilling rows for empty options
            acc.push(...createPrefillRow(entries)(text));
          }
          return acc;
        }, []);
        dispatch(bulkAddNewLoopEntries({
          entries: newEntries
        }));
      }
    }
    return () => {
      if (!interactiveClient) {
        sheetStore = {};
      }
    };
  }, dependencies); // should run, and sheet
};